'use client';

import { useState } from 'react';
import ObjectViewer from 'components/collection/object-viewer';
import { lofiArtworkObjectModel } from 'helpers/collection';
import type {
	GraphQLObject,
	IGraphQLObjectPackageObject,
} from '@metmuseum/types/src/graphql-object';
import styles from './object-viewer-button.module.scss';
import ImageIcon from 'assets/icons/image.svg';
import ClientPortal from 'components/helper/client-portal';

export const ObjectViewerButton = ({ object, text }: IProps) => {
	const [showObjectViewer, setShowObjectViewer] = useState(false);

	const formattedObject = lofiArtworkObjectModel(object);
	const handleObjectClick = (e) => {
		e.preventDefault();
		setShowObjectViewer(true);
	};

	const handleCloseClick = () => setShowObjectViewer(false);

	return (
		<>
			<span className={styles.noWrap}>
				(
				<button
					title={`Preview of "${formattedObject.title}"`}
					className={styles.button}
					onClick={handleObjectClick}
				>
					<ImageIcon className={styles.icon} />
					<span className={styles.text}>{text}</span>
				</button>
				)
			</span>
			{showObjectViewer && (
				<ClientPortal>
					<ObjectViewer
						objects={[formattedObject]}
						initialActiveObjectIndex={0}
						handleCloseClick={handleCloseClick}
					/>
				</ClientPortal>
			)}
		</>
	);
};

interface IProps {
	text: string;
	object: IGraphQLObjectPackageObject | GraphQLObject;
}
